import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';

interface ModelParams {
  page?: string;
  pageSize?: string;
  query?: string;
  sortBy?: string;
  sortDirection?: string;
  eventType?: string;
  status?: string;
  locationIds?: string;
  startDate?: string;
  endDate?: string;
}

export default class HrisDashboardAuditLogRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;

  controllerName = 'location-overview/hris-dashboard/audit-log';
  templateName = 'location-overview/hris-dashboard/audit-log';

  queryParams = {
    page: { refreshModel: true },
    pageSize: { refreshModel: true },
    query: { refreshModel: true },
    sortBy: { refreshModel: true },
    sortDirection: { refreshModel: true },
    eventType: { refreshModel: true },
    status: { refreshModel: true },
    locationIds: { refreshModel: true },
    startDate: { refreshModel: true },
    endDate: { refreshModel: true },
  };

  model(params: ModelParams): Promise<unknown> {
    const qs = new URLSearchParams();
    if (params.page) qs.append('page', params.page);
    if (params.pageSize) qs.append('page_size', params.pageSize);
    if (params.query) qs.append('query', params.query);
    if (params.sortBy) qs.append('sort_by', params.sortBy);
    if (params.sortDirection) qs.append('sort_direction', params.sortDirection);
    if (params.eventType) qs.append('event_type', params.eventType);
    if (params.status) qs.append('status', params.status);
    if (params.locationIds) qs.append('location_ids', params.locationIds);
    if (params.startDate) qs.append('start_date', params.startDate);
    if (params.endDate) qs.append('end_date', params.endDate);
    const queryString = qs.toString();
    return this.ajaxFetch.request(`/api/v1/hris/audit-log${queryString ? `?${queryString}` : ''}`);
  }
}
